import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'What ages is this kit designed for?',
  answer: 'The Small Big Emotions kit is designed for children ages 3-10. The games and activities can be adapted for different developmental stages, and the parent guide includes age-specific tips.'
}, {
  question: 'How do I receive the kit?',
  answer: "This is a digital product. After purchase, you'll receive an instant download link via email. You can print the materials at home on any standard printer."
}, {
  question: 'Do I need to be a therapist or expert to use this?',
  answer: "Not at all! The kit comes with a comprehensive parent/teacher guide with step-by-step instructions. It's designed to be intuitive and easy to use for anyone."
}, {
  question: 'Can I print it in black and white?',
  answer: "Yes! While the materials look beautiful in color, they're designed to work perfectly in black and white too."
}, {
  question: "What if it doesn't work for my child?",
  answer: "We offer a 30-day money-back guarantee. If you're not seeing results, contact us for a full refund — no questions asked."
}, {
  question: 'Can I use this in a classroom setting?',
  answer: 'Absolutely! Many teachers use the kit for morning circles, SEL lessons, and conflict resolution. The license allows printing for personal or single-classroom use.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-lavender relative" data-id="element-61">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-63">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-dark" data-id="element-64">
            Frequently Asked Questions
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-65">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-2xl overflow-hidden shadow-sm" data-id="element-66">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={isOpen} data-id="element-67">
                  <span className="font-heading font-bold text-lg text-dark pr-4" data-id="element-68">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-primary flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-69" />
                </button>
                <AnimatePresence data-id="element-70">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-71">
                      <div className="px-6 pb-5 text-muted leading-relaxed" data-id="element-72">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}